var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import { ofType } from "redux-observable";
import { from, merge, of } from "rxjs";
import { catchError, switchMap } from "rxjs/operators";
import { BuildingStateType, CommandCode, } from "../../../../utils/network/generated/protoTypes";
import { actionBaseInfoUpdateBuilding } from "../../../info/base/actionBaseInfo";
import { actionInventoryInfoRemoveResource } from "../../../info/inventory/actionInventoryInfo";
import { actionModalCloseAll } from "../../../modals/actionModal";
import { actionOngoingPurchasePremiumDeselect } from "../../../ongoing-purchase/actionOngoingPurchase";
import { actionBuildingsCancelPlacement, actionBuildingsDeselect, TypeActionBuildings, } from "../actionBuildings";
export var epicBuildingsRequestUpgradeConfirmed = function (action$, state$, deps) {
    return action$.pipe(ofType(TypeActionBuildings.UpgradeConfirmed), switchMap(function (action) {
        var state = state$.value;
        var premium = action.premium, building = action.building;
        if (premium && !state.ongoingPurchase.premium.isConfirmed) {
            return of(actionOngoingPurchasePremiumDeselect());
        }
        var proto = building.proto;
        return merge(deps
            .netSend({
            id: premium
                ? CommandCode.StartUpgradeGold
                : CommandCode.StartUpgradeResource,
            props: {
                buildingId: proto.id,
                farmId: state.playerBase.base.baseId,
                playerId: state.playerInfo.playerId,
            },
        })
            .pipe(switchMap(function (res) {
            return from([
                actionBaseInfoUpdateBuilding(__assign({}, proto, { remainingTime: res.remainingTime, state: BuildingStateType.UPGRADING })),
                actionInventoryInfoRemoveResource(res.cost),
            ]);
        }), catchError(function () { return of(actionBuildingsCancelPlacement()); })), from([
            actionOngoingPurchasePremiumDeselect(),
            actionBuildingsDeselect(),
            actionModalCloseAll(),
        ]));
    }));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/player-base/buildings/epics/epicBuildingsRequestUpgradeConfirmed.ts
// module id = 2083
// module chunks = 3